export default defineNuxtRouteMiddleware((to) => {
  if (queryValueToNumber(to.query.page) === 1) {
    delete to.query.page
    return navigateTo(to, { redirectCode: 301 })
  }
})
